import { Seo } from '@/components/Seo';
import { JsonLd, makeBreadcrumbSchema } from '@/components/Schema';

export function Privacy() {
  return (
    <>
      <Seo
        title="Privacy Policy | ai-free-resume"
        description="ai-free-resume privacy policy. Your resume data is stored locally in your browser. We do not sell your data."
        path="/privacy"
        noindex
      />
      <JsonLd schema={makeBreadcrumbSchema([{ name: 'Privacy Policy', path: '/privacy' }])} />

      <section className="bg-[#F6F9FC] py-16 md:py-24">
        <div className="mx-auto max-w-[800px] px-6">
          <div className="rounded-2xl bg-white p-8 md:p-12 shadow-sm">
            <h1 className="text-3xl font-bold text-[#0A2540] md:text-4xl">Privacy Policy</h1>
            <p className="mt-4 text-sm text-[#718096]">Last updated: July 19, 2026</p>

            <h2 className="mt-8 text-xl font-semibold text-[#0A2540]">1. Data Storage</h2>
            <p className="mt-2 text-[#4A5568]">
              Your resume data is stored locally in your browser using localStorage. We do not store your resume on our servers unless you explicitly choose to share it for support purposes.
            </p>

            <h2 className="mt-8 text-xl font-semibold text-[#0A2540]">2. AI Rewrite</h2>
            <p className="mt-2 text-[#4A5568]">
              When you use the AI Rewrite feature, we send the specific bullet text and job context to our AI provider. We do not use your data to train AI models.
            </p>

            <h2 className="mt-8 text-xl font-semibold text-[#0A2540]">3. Cookies and Tracking</h2>
            <p className="mt-2 text-[#4A5568]">
              We use a minimal anonymous browser ID to enforce the free AI rewrite quota. We do not use third-party advertising cookies or trackers.
            </p>

            <h2 className="mt-8 text-xl font-semibold text-[#0A2540]">4. Data Sharing</h2>
            <p className="mt-2 text-[#4A5568]">
              We do not sell your personal information. We only share data with our AI provider when you use AI features, and with analytics providers in aggregated form.
            </p>

            <h2 className="mt-8 text-xl font-semibold text-[#0A2540]">5. Contact</h2>
            <p className="mt-2 text-[#4A5568]">
              For privacy questions, contact us at support@ai-free-resume.org.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default Privacy;
